<template>
  <div class="layout">
    <Layout :style="{height:'100vh'}">
      <Sider breakpoint="md"
             :collapsed-width="78"
             v-model="isCollapsed"
             :style="{zIndex:'900'}">
        <div class="logo-img">
          <a href="javaScript:;">
            <img src="/img/top.png"
                 alt />
          </a>
        </div>
        <Menu active-name="1-2"
              width="auto"
              :class="menuitemClasses"
              accordion>
          <!-- 一级分类 -->
          <div :name="one.name"
               theme="light"
               v-for="one in menuData"
               :key="one.id">
            <div class="left_one">
              <Icon type="ios-more" />
              {{ one.name }}
            </div>
            <!-- 二级分类 -->
            <Submenu :name="two.name"
                     theme="light"
                     v-for="two in one.submenu"
                     :key="two.id">
              <template slot="title">
                <Icon :type="two.icon" />
                {{ two.name }}
              </template>
              <!-- 三级分类 -->
              <MenuItem :name="there.name"
                        v-for="there in two.there"
                        :key="there.id"
                        :to="'/' + there.url">
              {{ there.name }}
              <Icon type="ios-arrow-round-forward"
                    :style="{float: 'left'}" />
              </MenuItem>
            </Submenu>
          </div>
        </Menu>
      </Sider>
      <Layout>
        <Header class="layout-header-bar">
          <Breadcrumb class="f-l bread">
            <BreadcrumbItem v-for="item in breadCrumbList"
                            :to="item.to"
                            :key="item.id">{{ item.name }}</BreadcrumbItem>
          </Breadcrumb>
          <!-- 退出 -->
          <Button class="right-top-btn"
                  icon="ios-power"
                  type="text"
                  ghost
                  @click="handleDropDownClick('logout')"></Button>
          <Dropdown @on-click="handleDropDownClick($event)"
                    class="f-r">
            <span>
              <!-- <Avatar src="/img/touxiang.png" /> -->
              {{ username }}
              <Icon type="ios-arrow-down"></Icon>
            </span>
            <DropdownMenu slot="list">
              <DropdownItem name="editpassword">修改密码</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <!-- <span class="f-r">
                        <Avatar src="/console/img/login_logo.png"/> {{ username }}
          </span>-->
        </Header>
        <!-- 标题 + 按钮组 -->
        <div class="right_top_bg clearfix">
          <div class="right_top clearfix">
            <h4 class="f-l right-titles">{{ title }}</h4>
          </div>
        </div>
        <Content :style="{ padding:'15px', background:'#fff'}">
          <keep-alive>
            <router-view v-if="$route.meta.keepAlive">
              <!-- 这里是会被缓存的视图组件，比如 Home！ -->
            </router-view>
          </keep-alive>

          <router-view v-if="!($route.meta.keepAlive)"></router-view>
          <Modal v-model="showResetFirstPwdStatus"
                 title="修改密码"
                 :footer-hide="true">
            <Form :model="resetFirstPwdData"
                  ref="resetFirstPwdValidate"
                  :rules="resetFirstPwdValidate"
                  action="javascript:void(0)">
              <FormItem label="密码( 必须6-15位，且必须包含大小写字母、数字、特殊字符 ! @ # $ % & . _ )"
                        prop="password">
                <Input v-model="resetFirstPwdData.password"
                       type="password"
                       placeholder="输入密码..."></Input>
              </FormItem>
              <FormItem label="确认密码"
                        prop="password_confirmation">
                <Input v-model="resetFirstPwdData.password_confirmation"
                       type="password"
                       placeholder="确认密码..."></Input>
              </FormItem>
              <div class="clearfix">
                <Button :loading="resetFirstPwdLoading"
                        class="f-r"
                        type="primary"
                        @click="resetFirstPwd('resetFirstPwdValidate')">确定
                </Button>
                <Button class="f-r"
                        type="text"
                        @click="cancelResetFirstPwd('resetFirstPwdValidate')">
                  取消
                </Button>
              </div>
            </Form>
          </Modal>
        </Content>
        <Footer class="layout-footer-center">2025-2026 &copy; 今非昔比</Footer>
      </Layout>
    </Layout>
  </div>
</template>

<script>
import router from "../.././router";
import { LOGOUT, LOGIN } from "../.././vuex/mutation_types";
import md5 from "js-md5";
export default {
  data () {
    const pwdCheck = (rule, value, callback) => {
      let numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];
      let englishAlphabet = ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', 'a', 's', 'd', 'f',
        'g', 'h', 'j', 'k', 'l', 'z', 'x', 'c', 'v', 'b', 'n', 'm'];
      let specialCharacters = ['!', '@', '#', '$', '%', '&', '.', '_'];
      let isNumber = false;
      let isEnglishAlphabet = false;
      let isBigEnglishAlphabet = false;
      let isSpecialCharacters = false;
      numbers.forEach(item => {
        if (value.indexOf(item) !== -1) {
          isNumber = true;
        }
      });
      englishAlphabet.forEach(item => {
        if (value.indexOf(item) !== -1) {
          isEnglishAlphabet = true;
        }
        if (value.indexOf(item.toUpperCase()) !== -1) {
          isBigEnglishAlphabet = true;
        }
      });
      specialCharacters.forEach(item => {
        if (value.indexOf(item) !== -1) {
          isSpecialCharacters = true;
        }
      });
      if (isNumber && isEnglishAlphabet && isBigEnglishAlphabet && isSpecialCharacters) {
        callback();
      } else {
        callback(new Error("密码格式错误"));
      }
    };
    return {
      resetFirstPwdLoading: false,
      showResetFirstPwdStatus: false,
      isCollapsed: false, // 侧栏开关
      menuData: [], // 左侧菜单
      breadCrumbList: [], // 面包屑
      title: "首页", // 标题
      btns: [], // 功能按钮组
      resetFirstPwdData: {
        password: '',
        password_confirmation: '',
      },
      resetFirstPwdValidate: {
        password: [
          { required: true, message: "密码必须填写", trigger: "blur" },
          {
            type: "string",
            min: 6,
            max: 15,
            message: "密码 6 - 15 位长度",
            trigger: "blur",
          },
          { validator: pwdCheck, trigger: 'blur' }
        ],
        password_confirmation: [
          { required: true, message: "请重新输入密码", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    // 登录状态
    username () {
      return this.$store.getters.user_id != 0
        ? this.$store.getters.user_name
        : "未登陆";
    },
    menuitemClasses: function () {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    }
  },
  created: function () {
    this.getMenuData();
    var self = this;
    // 初始化面包屑及标题+按钮组
    var params = {
      label: this.$route.name
    };
    this.$api.common.breadcrumb(params).then(res => {
      this.breadCrumbList = res.result.breadcrumb;
      this.title = res.result.title;
      this.btns = res.result.btns;
    });
    // 路由结束后更新面包屑及标题+按钮组
    router.afterEach((to, from) => {
      var params = {
        label: to.name
      };
      // 这里是个大坑，不判断登录页面会在退出时让登录页面进入死循环，全局的钩子还是要少加为好
      if (to.name !== "login") {
        this.$api.common.breadcrumb(params).then(res => {
          this.breadCrumbList = res.result.breadcrumb;
          this.title = res.result.title;
          this.btns = res.result.btns;
        });
        this.getIsResetFirstPwd();
      }
    });
    this.getIsResetFirstPwd();
  },
  methods: {
    handleDropDownClick: function (name) {
      if (name == "logout") {
        this.$store.commit(LOGOUT);
        // 跳转到登录
        router.push("/");
      }
      if (name == "editpassword") {
        // 跳转到修改密码
        router.push("/admin/editpwd");
      }
    },
    getMenuData: function () {
      var self = this;
      this.$api.menu.left().then(res => {
        this.menuData = res.result;
      });
      return self.menuData;
    },
    resetFirstPwd (name) {
      console.log(1);
      this.resetFirstPwdLoading = true;
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$api.admin.resetFirstPwd({ password: md5(this.resetFirstPwdData.password), password_confirmation: md5(this.resetFirstPwdData.password_confirmation), }).then((res) => {
            console.log(2);
            if (res.code == 200) {
              console.log(3);
              this.$Message.success(res.msg);
              this.cancelResetFirstPwd(name);
            } else {
              console.log(4);
              this.resetFirstPwdLoading = false;
            }
          });
        } else {
          console.log(9);
          this.$Message.error("请检查输入的信息是否正确！");
          this.resetFirstPwdLoading = false;
        }
      });
    },
    getIsResetFirstPwd () {
      this.$api.admin.isResetFirstPwd().then(res => {
        if (res.code == 200) {
          if (res.result.is_reset_first_pwd == 0) {
            this.showResetFirstPwdStatus = true;
          }
        }
      });
    },
    cancelResetFirstPwd (name) {
      this.$refs[name].resetFields();
      this.resetFirstPwdData.password = '';
      this.resetFirstPwdData.password_confirmation = '';
      this.showResetFirstPwdStatus = false;
      this.resetFirstPwdLoading = false;
    },
  }
};
</script>
